import React from "react";
import { Link } from "gatsby";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./ContactUsCustomerSupport.css";
import PostCardIcon from "../../../images/contact-us/post.svg";
import PhoneIcon from "../../../images/contact-us/telephone.svg";

const ContactUsCustomerSupport = () => {
    return (
        <WidgetContainer>
            <div className="cu-customer-support">
                <div className="cu-customer-support__head">
                    <h1>Customer Support Details</h1>
                    <p>
                        Ask us anything and we'll help you find the answers.
                        Response time: within 24 hours
                    </p>
                </div>
                <div className="cu-customer-support__content">
                    <div className="cu-customer-support__content__item">
                        <h2>Help</h2>
                        <p>
                            Need help with the PhonePe app? Send us a message
                            and we'll get back to you at the earliest.
                        </p>
                        <div className="cu-customer-support__content__item__cbp">
                            <p>
                                <img
                                    src={PostCardIcon}
                                    width="34"
                                    height="24"
                                    alt="Post Card Icon"
                                />
                            </p>
                            <p>
                                <a
                                    className="purple-text"
                                    href="https://support.phonepe.com/"
                                    target="_top"
                                >
                                    Send a message
                                </a>
                            </p>
                            <br />
                            <p>
                                <img
                                    src={PhoneIcon}
                                    width="28"
                                    height="28"
                                    alt="Phone Icon"
                                />
                            </p>
                            <p id="cs-cn">
                                <span className="purple-text">Contact Us</span>
                                <br />
                                <span>080-68727374 &#47; 022-68727374</span>
                            </p>
                        </div>
                        <div className="cu-customer-support__content__item__cbp"></div>
                    </div>
                    <div className="cu-customer-support__content__item">
                        <h2>Grievances</h2>
                        <p>
                            Get in touch with us to escalate any existing
                            complaints, and we will ensure a quick resolution.
                        </p>
                        <div className="cu-customer-support__content__item__cbp">
                            <p>
                                <img
                                    src={PostCardIcon}
                                    width="34"
                                    height="24"
                                    alt="Post Card Icon"
                                />
                            </p>
                            <p>
                                <Link
                                    className="purple-text"
                                    to="/privacy-policy#grievances"
                                >
                                    Send a message
                                </Link>
                            </p>
                        </div>
                    </div>
                    <div className="cu-customer-support__content__item">
                        <h2>Ombudsman</h2>
                        <p>
                            You can direct your complaints to our regulating
                            authority by using the link here and sending them a
                            message.
                        </p>
                        <div className="cu-customer-support__content__item__cbp">
                            <p>
                                <img
                                    src={PostCardIcon}
                                    width="34"
                                    height="24"
                                    alt="Post Card Icon"
                                />
                            </p>
                            <p>
                                <Link
                                    className="purple-text"
                                    to="/privacy-policy#grievances"
                                >
                                    Send a message
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default ContactUsCustomerSupport;
